import { ReactElement } from "react";
import Layout from "../../../components/layout";
import ShopCampaigns from "../../../components/Shops/Campaigns/index";

const ShopCampaignPage = (): ReactElement => {
  return (
    <Layout>
      <ShopCampaigns />
    </Layout>
  );
};

export default ShopCampaignPage;
